import { asyncRoutes } from '@/router'
import { buildTree } from '@U/handle'
import store from '@S'
import _ from 'lodash'

export function handleMenuRoutes(routes) {
  const res = []
  routes = _.sortBy(routes, item => {
    return item.routerIndex
  })
  routes.forEach(route => {
    const tmp = { ...route }
    if (tmp.children) {
      tmp.children = handleMenuRoutes(tmp.children)
    }
    if (tmp.visible) {
      res.push({
        name: tmp.name,
        alwaysShow: !!(tmp.children && tmp.children.length),
        meta: {
          icon: tmp.parentId === -1 ? tmp.icon || 'tree' : '',
          title: store.getters.isZh ? tmp.name : tmp.enName
        },
        path: tmp.menuUrl,
        children: tmp.children
      })
    }
  })
  return res
}

export function handleAsyncRoutes(routes) {
  const res = []
  routes = _.sortBy(routes, item => {
    return item.routerIndex
  })
  routes.forEach(route => {
    const tmp = { ...route }
    if (tmp.children) {
      tmp.children = handleAsyncRoutes(tmp.children)
    }
    if (tmp.name !== 'Dashboard') {
      const item = {
        path: route.menuUrl,
        name: route.name,
        meta: { title: store.getters.isZh ? route.name : route.enName },
        children: tmp.children,
        visible: route.visible,
        redirect: tmp.parentId !== -1 ? null : getRedirect(tmp),
        component:
          tmp.parentId !== -1
            ? resolve => require(['@/views' + route.menuPath + '.vue'], resolve)
            : resolve => require(['@/layout/index.vue'], resolve)
      }
      res.push(item)
    }
  })
  return res
}

function getRedirect(tmp) {
  if (!tmp.children || !tmp.children.length) {
    return null
  }
  const obj = tmp.children.find(item => {
    return item.visible
  })
  return obj ? obj.path : null
}

const state = {
  routes: [],
  addRoutes: []
}

const mutations = {
  SET_ROUTES: (state, routes) => {
    state.addRoutes = routes
    state.routes = routes
  },
  REMOVE_ROUTES: state => {
    state.routes = []
  }
}

const actions = {
  buildRoutes({ commit }, userMenus) {
    return new Promise(resolve => {
      const userMenusTree = buildTree(userMenus)
      const menuRoutes = handleMenuRoutes(userMenusTree)

      const asyncRoutesArr = handleAsyncRoutes(userMenusTree)
      asyncRoutesArr.push({ path: '*', redirect: '/404', hidden: true })
      const routers = asyncRoutes.concat(asyncRoutesArr)
      routers[0].redirect = asyncRoutesArr[0].path
      commit('SET_ROUTES', menuRoutes)
      resolve(routers)
    })
  },
  removeRoutes({ commit }) {
    commit('REMOVE_ROUTES')
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
